import SignInPage from "./ui/auth/SignInPage";
import TopicPage from "./ui/pages/TopicPage";
import TrainingPage from "./ui/pages/TrainingPage";
import TestimonyPage from "./ui/pages/TestimonyPage";
import CategoryPage from "./ui/pages/CategoryPage";
import TrainingVersionPage from "./ui/pages/TrainingVersionPage";

const appRoutes = {
  home: "/",
  training: "/topic/:trainingId",
  topic: "/topic/:trainingId/:topicId",
  topicPart: "/topic/:trainingId/:topicId/:topicPartId",
  category: "/category/:trainingId",
  testimony: "/testimony/:trainingId",
  trainingVersions: "/training-versions/:trainingId",

  signin: "/signin",
};

const authRoutes = [appRoutes.signin];

const isAuthRoute = () => authRoutes.includes(location.pathname);

const appPages = {
  home: {
    path: appRoutes.home,
    element: <TrainingPage />,
  },
  training: {
    path: appRoutes.training,
    element: <TrainingPage />,
  },
  topic: {
    path: appRoutes.topic,
    element: <TopicPage />,
  },
  category: {
    path: appRoutes.category,
    element: <CategoryPage />,
  },
  testimony: {
    path: appRoutes.testimony,
    element: <TestimonyPage />,
  },
  trainingVersions: {
    path: appRoutes.trainingVersions,
    element: <TrainingVersionPage />,
  },
  login: {
    path: appRoutes.signin,
    element: <SignInPage />,
  },
};

export { appRoutes, isAuthRoute, appPages };
